import React from "react"
import { NavLink } from 'react-router-dom'

export default () => {
  return <div className="menu">
           <NavLink to={ "/" } className={({ isActive }) => isActive ? 'active' : ''}> Schedule </NavLink>
           <NavLink to={ "/birl" } className={({ isActive }) => isActive ? 'active' : ''}> Birl </NavLink>
         </div>
}
